import React, { useMemo, useEffect, useState } from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { styleModalBoxProductos } from "verticales/StylesGene";

function UtilModal(props: any) {
  return (
    <React.Fragment>
      <Modal
        open={props.openModal}
        onClose={props.handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalBoxProductos}>{props.renderView()}</Box>
      </Modal>
    </React.Fragment>
  );
}

export default UtilModal;
